import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { siteData } from '../config/config'
import { quickLinks } from '../data/localData'
import { Link } from 'react-router-dom'
import { IoCall, IoMailOutline } from 'react-icons/io5'
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa'
import Flag from 'react-world-flags'

function Footer() {
  return (
    <div className='footer-main bg-contra-color'>
      <Container className='pt-5 pb-4'>
        <Row className='gy-5'>
          <Col className='col-12 col-sm-6 col-lg-3'>
            <div className='d-grid gap-3'>
              <Link to={'/'} className='logo-holder'>
                <img src={siteData?.logoContra} alt="" />
              </Link>
              <p className='m-0 fs-sm-10 fs-md-12 fs-14'>{siteData?.slogan}</p>
            </div>
          </Col>
          <Col className='col-12 col-sm-6 col-lg-2'>
            <div className='d-grid ps-lg-3'>
              <h4 className='fs-sm-20 fw-semibold'>Quick Links</h4>
              {
                quickLinks.map((links, index) => {
                  return (
                    <Link key={index} to={links?.value} className='text-decoration-none py-0 py-sm-1 link-text'>{links?.label}</Link>
                  )
                })
              }
            </div>
          </Col>
          <Col className='col-12 col-sm-6 col-lg-4'>
            <div className='d-grid'>
              <h4 className='fs-sm-20 fw-semibold pb-2'>Location</h4>
              <div className='d-flex gap-1'>
                <b className='fw-bold fs-14 fs-md-12 fs-sm-10'>Plant  <Flag code="IN" style={{ width: '18px', height: '16px' }} /> :</b>
                <address className='fs-14 fs-md-12 fs-sm-10'>
                  Block No. 125, NH -8, Valthan Village, 
                  <br />
                  Tal Kamrej, Dist. Surat-394325, 
                  <br />
                  Gujarat (India)
                </address>
              </div>
              <div className='d-flex gap-1'>
                <b className='fw-bold fs-14 fs-md-12 fs-sm-10'>Office  <Flag code="IN" style={{ width: '18px', height: '16px' }} /> :</b>
                <address className='fs-14 fs-md-12 fs-sm-10'>
                  3A, 4th Floor, Dolphin House,
                  <br />
                  Nr. Tapi Baug Society, Mini Bazar,
                  <br />
                  Varachha Main Road, Surat-395006
                </address>
              </div>
              <div className='d-flex gap-1'>
                <b className='fw-bold fs-14 fs-md-12 fs-sm-10'>Office  <Flag code="GB" style={{ width: '18px', height: '16px' }} /> :</b>
                <address className='fs-14 fs-md-12 fs-sm-10'>
                  92, Oldfield road, Sutton,
                  <br />
                  SM12NU, United Kingdom
                </address>
              </div>
            </div>
          </Col>
          <Col className='col-12 col-sm-6 col-lg-3'>
            <div className='d-grid'>
              <h4 className='fs-sm-20 fw-semibold mb-3'>Quick Contact</h4>
              <div className='d-grid gap-2 gap-sm-3'>
                {siteData.mobile.map((mobile, index) => {
                  return (
                    <a key={index} href={`tel:${mobile.value}`} className="flex-center-align justify-content-start text-decoration-none link-text gap-2 fs-md-14 fs-sm-12">
                      <IoCall /> {mobile.label}
                    </a>
                  )
                })}
                <a href={`mailto:${siteData.email}`} className="flex-center-align justify-content-start text-decoration-none link-text gap-2 fs-md-14 fs-sm-12">
                  <IoMailOutline />  {siteData.email}
                </a>
                <div className='flex-center-align gap-4 social-icons justify-content-start'>
                  <Link target='_blanck' to={"https://www.facebook.com/share/1FGkoaTTVe/?mibextid=wwXIfr"}><FaFacebook /></Link>
                  <Link target='_blanck' to={"https://www.instagram.com/nexus_paper_packs/profilecard/?igsh=MWFsYmQ3N29iMTJ2cQ=="}><FaInstagram /></Link>
                  <Link target='_blanck' to={"https://www.linkedin.com/company/nexus-paper-packs/"}><FaLinkedin /></Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <hr />
        <div className='text-center fs-14 fs-md-12 fs-sm-10'>Copyright © 2024 , Nexus paper packs. All Rights Reserved</div>
      </Container>

    </div >
  )
}

export default Footer